<template>
  <v-app>
  </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
//import ddoAlert from '@/components/ddoAlert.vue';
//import ddoWaiting from '@/components/ddoWaiting.vue'
import BasicComponent from '@/views/BasicComponent.vue';
import ddoClientList from '@/components/ddoClientList.vue';
import { Event } from '@/components/ddoClientList.vue';

let initial_row = {}

export default {
   name: 'basiclist',
   mixins: [BasicComponent],
   components: {
      ddoClientList,
   },

   data: () => {
      return {

         /* 
          * LEVEL 1 : all for ddoClientList : columns, options, callbacks
          */
         levels: [],

         useVuex: false,
         theme: 'bootstrap4',
         template: 'default',
      }
   },

   created() {
      this._this = this;
      if ( this.levels ) {
         this.initialize_levels(this.levels);
      }
   },

   mounted() {
   },

   methods: {

      refresh_errors(level,errors) {
         this.levels[level].errors = errors;
      },

      refresh_row(level,row) {
         this.levels[level].row = row;
      },

      refresh_childKey(level,key,toggledRow=null) {
         this.levels[level].childKey = key;
         this.levels[level].toggledRow = toggledRow;
      },

      configure_form(level,f_disabled,f_create,f_update,f_delete) {
         let _dV = this.levels[level].dialogValues;
         _dV.form_disabled = f_disabled;
         _dV.form_create   = f_create;
         _dV.form_update   = f_update;
         _dV.form_delete   = f_delete;
         this.levels[level].dialogValues = _dV;
      },

      show_dialog(level,show) {
         console.log('show_dialog, level='+level+', show='+show);
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         _dV.dialogShow   = show;
         this.levels[level].dialogValues = _dV;
      },

      async refresh_rows(key=null) {
         this.rows = [];
      },

      initialize_levels(levels) {
         console.log('initialize_levels');
         for ( var i=0;i<levels.length;i++ ) {
            if ( levels[i].dialogValues ) {
               levels[i].dialogValues.form_close  = true;
               levels[i].dialogValues.form_create = false;
               levels[i].dialogValues.form_update = false;
               levels[i].dialogValues.form_delete = false;
               levels[i].dialogValues.disable_close  = false;
               levels[i].dialogValues.disable_create = false;
               levels[i].dialogValues.disable_update = false;
               levels[i].dialogValues.disable_delete = false;
            }
         }
      },

   },

   provide: function() {
      return {
         refresh_rows: this.refresh_rows
      }
   }

}
</script>